import ng from 'angular';
import { IFolhaPonto } from '../../../models/folhaponto.model';

export class FolhasPontoCancelarAssinaturaModalController implements ng.IController {

    static $inject = [
        '$uibModalInstance',
        'entity',
    ];

    public comentario: string = '';

    constructor(
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public entity: IFolhaPonto,
    ) {}

    public confirmar(): void {
        if (!this.comentarioValido()) {
            return;
        }

        this.$uibModalInstance.close(this.comentario.trim());
    }

    public cancelar(): void {
        this.$uibModalInstance.dismiss('cancelar');
    }

    public comentarioValido(): boolean {
        return !!this.comentario && !!this.comentario.trim();
    }
}
